<template>
  <div class="mx-0 px-0">
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="mx-auto container-xl mb-5">
      <div class="">
        <div class="title-area">
          <h1 class="page-title h2 mb-2">Group: <span :class="`${anon ? 'g-anon-lg' : ''}`">{{ group_name }}</span>
          </h1>
        </div>
      </div>
      <!-- Group information -->
      <div class="d-flex border-section justify-content-between">
        <div class="table-responsive table w-100 table-no-padding-first mb-5">
          <h3 class="mt-4">Group information</h3>
          <table class="table first-td-500 table-alternative">
            <tbody>
            <tr>
              <td>
                {{ 'Group name' }}
              </td>
              <td class="editable normal-input">
                <input
                  v-if="editable"
                  class="form-control"
                  :class="`${anon ? 'g-anon' : ''}`"
                  @change="savefield('group_name',group_name)"
                  v-model="group_name"
                />
                <span v-else :class="`${anon ? 'g-anon' : ''}`">
                  {{ group.group_name }}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                Norm values
              </td>
              <td class="editable normal-input">
                <select
                  v-if="editable"
                  class="form-select col-12 col-lg-7 col-xl-6"
                  v-model="group_normvalues_id"
                  @change="savefield('group_normvalues_id',group_normvalues_id)"
                >
                  <option v-for="option in norm_values_options" :key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
                <span v-else :class="`${anon ? 'g-anon' : ''}`">
                  {{ (norm_values_options.find(n => String(n.value) === String(group.group_normvalues_id)) || {}).text || 'N/A' }}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                Language
              </td>
              <td class="editable normal-input">
                <select
                  v-if="editable"
                  class="form-select col-12 col-lg-7 col-xl-6"
                  v-model="group_language_id"
                  @change="savefield('group_language_id',group_language_id)"
                >
                  <option v-for="option in language_options" :key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
                <span v-else :class="`${anon ? 'g-anon' : ''}`">
                  {{ (language_options.find(l => String(l.value) === String(group_language_id)) || {}).text || 'N/A' }}
                </span>
              </td>
            </tr>
            </tbody>
          </table>
          <button :disabled="saving" class="btn btn-secondary btn-small mt-3" @click="toggleEditable">
              {{ editable ? 'Save' : 'Edit' }}
            </button>
        </div>
      </div>

      <!-- Group Members -->
      <div class="mb-4 pt-4 bt-1" style="border-top: 1px solid black !important;">
        <h3 class="m-0">Group Members</h3>
        <GroupMembers />
      </div>

      <!-- Group Surveys -->
      <div class="mb-4 pt-4 bt-1" style="border-top: 1px solid black !important;">
        <h3 class="m-0">Group surveys</h3>
        <GroupSurveys surveytype="ongoing" :groupid="group_id"/>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
import GroupSurveys from './GroupSurveys.vue'
import GroupMembers from './GroupMembers.vue'

export default {
  name: 'GroupPage',
  components: {
    Navbar,
    Breadcrumb,
    GroupSurveys,
    GroupMembers
  },
  data () {
    return {
      saving: false,
      editable: false,
      loading: false,
      group_id: this.$store.state.currentgroup_id,
      group_name: null,
      group_language_id: null,
      group_normvalues_id: null
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    group: {
      get () {
        return this.$store.state.currentgroup
      }
    },
    language_options: {
      get () {
        const items = this.$store.state.languages
        const options = []
        options.push({ value: 0, text: 'Please select a language' })
        for (let i = 0; i < items.length; i++) {
          const option = {
            value: items[i].id,
            text: items[i].language_name
          }
          options.push(option)
        }
        return options
      },
      set () {
        return true
      }
    },
    norm_values_options: {
      get () {
        const items = this.$store.state.normvalues_countries
        const options = []
        options.push({ value: 0, text: 'Please select norm values' })
        for (let i = 0; i < items.length; i++) {
          const option = {
            value: items[i].country_id,
            text: items[i].country_name
          }
          options.push(option)
        }
        return options
      },
      set () {
        return true
      }
    }
  },
  created () {
    this.group_get()
    this.languages_get()
    this.normvalues_countries_get()
  },
  methods: {
    toggleEditable () {
      this.editable = !this.editable
      const rows = document.querySelectorAll('.table-alternative tr')
      rows.forEach(row => {
        if (this.editable) {
          row.classList.add('editable-row')
        } else {
          row.classList.remove('editable-row')
          this.saveform()
        }
      })
    },
    saveform () {
      if (!this.saving) {
        this.saving = true
        const data = {
          id: this.$store.state.currentgroup.id,
          group_name: this.group_name,
          group_language_id: this.group_language_id,
          group_normvalues_id: this.group_normvalues_id
        }
        this.$store.dispatch('group_save', { group: data })
          .then(() => {
            this.group_get()
            this.saving = false
          })
      }
    },
    savefield (fieldname, value) {
      const data = {
        id: this.$store.state.currentgroup.id,
        [fieldname]: value
      }
      this.$store.dispatch('group_save', { group: data })
    },
    group_get: function () {
      this.$store.dispatch('group_fetch', { id: this.group_id })
        .then(() => {
          this.group_name = this.$store.state.currentgroup.group_name
          this.group_language_id = this.$store.state.currentgroup.group_language_id
          this.group_normvalues_id = this.$store.state.currentgroup.group_normvalues_id
          this.loading = false
        })
    },
    languages_get: function () {
      this.$store.dispatch('languages_fetch')
    },
    normvalues_countries_get: function () {
      this.$store.dispatch('normvalues_countries_fetch')
    }
  }

}
</script>
<style scoped>
</style>